import React from "react";
import "./BackButton.css";

const BackButton = ({ onClick = () => console.log("Back button clicked") }) => {
  return (
    <button className="back-button" onClick={onClick} aria-label="Go back">
      <svg
        style={{ pointerEvents: "none" }}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15 19l-7-7 7-7"
          stroke="#A4AAB3"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </button>
  );
};

export default BackButton;
